__turbopack_context__.v({
  "apply-button": "inline-panel-filters-module-scss-module__Ry99-a__apply-button",
  "footer": "inline-panel-filters-module-scss-module__Ry99-a__footer",
  "range-divider": "inline-panel-filters-module-scss-module__Ry99-a__range-divider",
  "range-field": "inline-panel-filters-module-scss-module__Ry99-a__range-field",
  "range-row": "inline-panel-filters-module-scss-module__Ry99-a__range-row",
  "reset-button": "inline-panel-filters-module-scss-module__Ry99-a__reset-button",
  "root": "inline-panel-filters-module-scss-module__Ry99-a__root",
  "scrollable": "inline-panel-filters-module-scss-module__Ry99-a__scrollable",
});
